export default {
  // meta
  ID: "ID",
  Shop: "Boutique",
  "Stock Batch": "Lot de stock",
  Supplier: "Fournisseur",
  Quantity: "Quantité",
  "Created At": "Créé le",
  Actions: "Actions",

  // form
  "Create Supply Return": "Créer un retour fournisseur",
  "Edit Supply Return": "Modifier le retour",

  // table
  "All shops": "Toutes les boutiques",

  // select
  "Supply Return": "Retour fournisseur",
  "Search by ID, shop, batch or supplier":
    "Rechercher par ID, boutique, lot ou fournisseur",
  "Edit Selection": "Modifier la sélection",
  "No returns found": "Aucun retour trouvé",
  Qty: "Qté",
  units: "unités",

  // modals
  "Return Details": "Détails du retour",
  "Updated At": "Mis à jour le",

  // delete
  "Do you really want to delete this supply return?":
    "Voulez-vous vraiment supprimer ce retour fournisseur ?",
  "Warning: This action is irreversible.":
    "Attention : cette action est irréversible.",
  "Confirm Deletion": "Confirmer la suppression",
  Cancel: "Annuler",

  // block
  "Supply Returns": "Retours fournisseurs",
  "Add Return": "Ajouter un retour",
  "Supply Return ID : ": "ID Retour Fournisseur : ",
  "Unit Price": "Prix unitaire",
  "Quantity to return": "Quantité à retourner",
  "Normal Cost": "Coût normal",
  "Amount to refund": "Montant à rembourser",
  quantity: "quantité",
  "Description / Observation": "Description / Observation",
  "Save the changes": "Enregistrer les modifications",
  "Create New Supply Return": "Créer un nouveau retour fournisseur",
  "Submit Supply Return": "Soumettre le retour fournisseur",
  qty: "qté",

  "Supply Returns Report": "Rapport des retours fournisseurs",
  "Batch Code": "Code du lot",
  Product: "Produit",
  product: "produit",
  supplier: "fournisseur",
  Amount: "Montant",
  amount: "montant",
  Status: "Statut",
  status: "statut",
  Pending: "En attente",
  pending: "en attente",
  Approved: "Approuvé",
  approved: "approuvé",
  Completed: "Terminé",
  completed: "terminé",
  Rejected: "Rejeté",
  rejected: "rejeté",
  "Set as pending": "Marquer comme en attente",
  "Set as approved": "Marquer comme approuvé",
  "Set as rejected": "Marquer comme rejeté",
};
